module.exports = __webpack_public_path__ + "files/8df6abab86b4d62ec2df606fafe9c163.png";